import { render, staticRenderFns } from "./VirtualDesktopItemBody.vue?vue&type=template&id=69503b29&scoped=true"
import script from "./VirtualDesktopItemBody.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopItemBody.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopItemBody.vue?vue&type=style&index=0&id=69503b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69503b29",
  null
  
)

export default component.exports